var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { QuillRichText, RichTextDialog } from "./ReactQuill";
export const RichTextField = (props) => {
    const { id, defaultValue, label, disabled, onChangeCallback, onExceedCharacterLimit, onFocus, onBlur, formatting, enableExpansion, mentionConfiguration, autoFocus, autoSelect } = props, quillRickTextFieldProps = __rest(props, ["id", "defaultValue", "label", "disabled", "onChangeCallback", "onExceedCharacterLimit", "onFocus", "onBlur", "formatting", "enableExpansion", "mentionConfiguration", "autoFocus", "autoSelect"]);
    const [isTextFieldExpanded, setIsTextFieldExpanded] = useState(false);
    const [richTextValue, setRichTextValue] = React.useState();
    const [richTextDialogValue, setRichTextDialogValue] = React.useState();
    const quillRef = React.useRef(null);
    const quillDialogRef = React.useRef(null);
    React.useEffect(() => {
        setRichTextValue(defaultValue);
    }, [JSON.stringify(defaultValue)]);
    const changeHandler = (value, delta, source, editor) => {
        if (source === "user") {
            setRichTextValue(editor.getContents());
            if (onChangeCallback)
                onChangeCallback(value, delta, source, editor);
        }
    };
    const changeDialogHandler = (value, delta, source, editor) => {
        if (source === "user") {
            setRichTextDialogValue(editor.getContents());
        }
    };
    // Define formats according to the given props
    const formats = React.useMemo(() => {
        const formats = [];
        if (formatting) {
            if (formatting.boldAndItalic) {
                formats.push("bold", "italic");
            }
            if (formatting.textAlignment) {
                formats.push("align");
            }
            if (formatting.textColor) {
                formats.push("color");
            }
            if (formatting.textBackgroundColor) {
                formats.push("background");
            }
            if (formatting.fontAndSize) {
                formats.push("font", "size");
            }
        }
        if (mentionConfiguration === null || mentionConfiguration === void 0 ? void 0 : mentionConfiguration.enableMentions) {
            formats.push("mention");
        }
        return formats;
    }, []);
    const handleExpand = (editor) => {
        setRichTextDialogValue(editor.getContents());
        setIsTextFieldExpanded(true);
    };
    const handleSaveDialog = () => {
        setRichTextValue(richTextDialogValue);
        setIsTextFieldExpanded(false);
        if (onBlur && !disabled) {
            const unprivilegedEditor = quillDialogRef.current.makeUnprivilegedEditor(quillDialogRef.current.editor);
            onBlur(unprivilegedEditor);
        }
        // We should probably call onChangeCallback here, but in order to do it we need to change its signature first. Currently, we don't have a use case for using this component with expansion and
        //      callback so we didn't do it.
    };
    return (_jsxs(_Fragment, { children: [enableExpansion &&
                _jsx(RichTextDialog, { title: label, open: isTextFieldExpanded, onClose: () => setIsTextFieldExpanded(false), onSave: handleSaveDialog, children: _jsx(QuillRichText, Object.assign({ id: `dialog-${id}`, quillRef: quillDialogRef, value: richTextDialogValue, formats: formats, isTextFieldExpanded: true, onChange: changeDialogHandler, label: label, disabled: disabled, enableExpansion: enableExpansion, mentionConfiguration: mentionConfiguration }, quillRickTextFieldProps)) }), _jsx(QuillRichText, Object.assign({ id: id, quillRef: quillRef, value: richTextValue, onChange: changeHandler, onExceedCharacterLimit: onExceedCharacterLimit, onFocus: onFocus, onBlur: onBlur, label: label, disabled: disabled, formats: formats, handleExpand: handleExpand, enableExpansion: enableExpansion, mentionConfiguration: mentionConfiguration, autoFocus: autoFocus, autoSelect: autoSelect }, quillRickTextFieldProps))] }));
};
//# sourceMappingURL=RichTextField.js.map